export interface SearchState {
    query: string;
    pageIndex: number;
    pageSize: number;
    orderBy: string;
    sortDirection: 'asc' | 'desc';
}

export const initialSearchState: SearchState = {
    query: '',
    pageIndex: 0,
    pageSize: 50,
    orderBy: 'dateAddedEPOCH',
    sortDirection: 'desc'
};

export type FacetType = 'assetTypes' | 'colorChannels' | 'fileTypes' | 'assetGroups' | 'productCategories';

export interface SearchAsset {
    assetId: string;
    assetClientKey: string;
    assetName: string;
    fileName: string;
    originalFileName: string;
    webUrl: string;
    printUrl: string;
    fileType: string;
    assetType: string;
    dateAdded: string;
    colorChannel: string;
    assetGroupId: string;
    assetGroupName: string;
    assetGroupClientKey: string;
    dateCreated: string;
    expiryDate: string;
    zipType: string;
    doNotUse: boolean;
}
